import { render, staticRenderFns } from "./LCDomains.vue?vue&type=template&id=cc2dcac0&scoped=true&"
import script from "./LCDomains.vue?vue&type=script&lang=ts&"
export * from "./LCDomains.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2dcac0",
  null
  
)

export default component.exports